export const STAKEHOLDER_FIELDS = `
  id
  projectId
  name
  jobTitle
  email
  phone
  note
  createdBy
  createdAt
  updatedBy
  updatedAt
`;
